import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NumberPicker } from '../../components';
import { PaxConstants } from '../../models';
import { ABUtils, isAgeSelectorEnabled } from '../../utils';

export const PaxSelectorContentRow = ({ cmsKey, min, max, paxKey, onChange, value, ageCmsKey, children, isTrainsProduct = false }) => {
    const { t } = useTranslation();
    const { isCssVariationMobile } = ABUtils.getABs();
    const isAgeSelectorActive = isAgeSelectorEnabled();
    const classRowGeneral = 'odf-flex-container-row odf-flex-container-nogutter odf-text-md';
    const classRowDevice = isCssVariationMobile ? 'odf-space-inner-bottom-s odf-space-inner-top-l' : 'odf-space-outer-bottom-m';
    const classRow = classNames(classRowGeneral, classRowDevice);
    const childrenArray = React.Children.toArray(children);
    return (
        <div className={classRow} data-testid="pax-selector-item" style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'row', width: '100%' }}>
                <div className="odf-flex-item odf-text-ellipsis">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t(
                                isTrainsProduct && isAgeSelectorActive
                                    ? `paxSelector.trains.${cmsKey}.text.plural`
                                    : `paxSelector.${cmsKey}.text`
                            ),
                        }}
                    />
                    {paxKey !== PaxConstants.ROOMS && (
                        <span
                            className="odf-space-inner-left-xs"
                            dangerouslySetInnerHTML={{
                                __html: t(
                                    isTrainsProduct && isAgeSelectorActive
                                        ? `${ageCmsKey}.trains.${cmsKey}.age`
                                        : `${ageCmsKey}.${cmsKey}.age`
                                ),
                            }}
                        />
                    )}
                </div>
                <div className="odf-flex-item odf-flex-item-sm">
                    <NumberPicker
                        min={min}
                        max={max}
                        value={value}
                        onChange={(val) => onChange({ [paxKey]: val })}
                    />
                </div>
            </div>
            {childrenArray.length > 0 && (
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '12px',
                        marginTop: '12px',
                        width: '100%',
                    }}
                >
                    {childrenArray}
                </div>
            )}
        </div>
    );
};

PaxSelectorContentRow.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    cmsKey: PropTypes.string.isRequired,
    paxKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    ageCmsKey: PropTypes.string,
    children: PropTypes.node,
    isTrainsProduct: PropTypes.bool,
};

PaxSelectorContentRow.defaultProps = {
    min: 0,
    ageCmsKey: 'paxSelector',
};
